import { FormikProps } from 'formik'
import { t } from 'i18next'
import { useMemo } from 'react'

import {
  CreateDemoTradingAccountFormValues,
  OuterProps,
} from '@pages/Traders-Room/Trading-Accounts/NewTradingAccount/Demo/CreateDemoTradingAccount.types'

import { useSessionEntity } from '@context/EntityContext'

import { TickmillCompaniesEnum, isTickmillASType, isTickmillSCType } from '@utils/companyName.utils'

import {
  PlatformTypeEnum,
  isTMTPlatformType,
  isTradingViewPlatformType,
} from '@model/PlatformTypeEnum'

export const useNewTradingAccountDemoData = (
  props: FormikProps<CreateDemoTradingAccountFormValues> & OuterProps
) => {
  const { values } = props

  const entity = useSessionEntity()

  const disabledFields = (): { [key: string]: boolean } => {
    return {
      currency: !values.platformType,
      classification: !values.accountType,
      type: !values.accountCurrency,
      leverage: !values.accountType || !values.accountCurrency,
      deposit:
        !values.leverageType ||
        (!values.classificationType &&
          entity !== TickmillCompaniesEnum.TICKMILL_SC &&
          entity !== TickmillCompaniesEnum.TICKMILL_AS),
    }
  }

  const isCurrencyDisabled = useMemo(() => {
    if (disabledFields().currency) {
      return true
    }

    if (values.accountCurrency?.id) {
      return false
    }

    return false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.platformType, values.accountCurrency?.id])

  const isClassificationTypeVisible = useMemo(() => {
    return !isTickmillSCType(entity) && !isTickmillASType(entity)
  }, [])

  const isLeverageDisabled = useMemo(() => {
    if (disabledFields().leverage) {
      return true
    }

    if (values.leverageType) {
      return false
    }

    return false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.leverageType, values.accountType, values.accountCurrency, values.platformType?.id])

  const subtitle = useMemo(() => {
    if (
      isTMTPlatformType(values.platformType?.id) ||
      isTradingViewPlatformType(values.platformType?.id)
    ) {
      return t(
        'Trading Account.When you open a Demo trading account a Live Trading account is automatically created'
      )
    } else if (
      values.platformType?.id === PlatformTypeEnum.MT4 ||
      values.platformType?.id === PlatformTypeEnum.MT5
    ) {
      return t('Trading Account.You can open up to seven Demo trading accounts')
    }
  }, [values.platformType?.id, t])

  return {
    subtitle,
    disabledFields,
    isLeverageDisabled,
    isCurrencyDisabled,
    isClassificationTypeVisible,
  }
}
